import { render, staticRenderFns } from "./p-setup-data.vue?vue&type=template&id=6b5f672a&scoped=true"
import script from "./p-setup-data.vue?vue&type=script&lang=js"
export * from "./p-setup-data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5f672a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b5f672a')) {
      api.createRecord('6b5f672a', component.options)
    } else {
      api.reload('6b5f672a', component.options)
    }
    module.hot.accept("./p-setup-data.vue?vue&type=template&id=6b5f672a&scoped=true", function () {
      api.rerender('6b5f672a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/mpackages/views/popups/p-add-package-popup/p-setup-data.vue"
export default component.exports